export default "__VITE_PUBLIC_ASSET__6907fa50__"